import axios, { AxiosResponse } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { NotificationSettingPayload } from './types';



export const getNotificationSettingsThunk = createAsyncThunk(
    'notifications/getNotificationSettings',
    async (projectId:number, { getState, rejectWithValue, ...thunkApi})=>{
        try{
            const response: AxiosResponse<any> = await axios.get(
                `/notification-types/${projectId}`
            )
            return response.data;
        } catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)

export const getEditNotificationSettingsThunk = createAsyncThunk(
    'notifications/getEditNotificationSetting',
    async (notificationId:number,{ getState, rejectWithValue, ...thunkApi})=>{
        try{
            const response: AxiosResponse<any> = await axios.get(
            `/get-edit-notifysetting/${notificationId}`
            )
            return response.data;
        }catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)

export const updateNotificationSettingsThunk = createAsyncThunk(
    'notifications/updateNotificationSettings',
    async (data:NotificationSettingPayload ,{ getState, rejectWithValue, ...thunkApi})=>{
        try{
            const apiUrl = data.type_id === 1?`update-all-notification-setting`:`update-project-notification-setting`
            const response: AxiosResponse<any> = await axios.post(
            `/${apiUrl}/${data.notification_id}`,data
            )
            return response.data;
        }catch(err){
            return rejectWithValue((err as any).response.data || err)
        }
    }
)